// Kept per user (keyed by Supabase user id) so a shared browser still shows
// the tour to each new trial user once.
const SEEN_KEY_PREFIX = 'trial_results_tour_seen_at:'

const seenKey = (userId: string) => `${SEEN_KEY_PREFIX}${userId}`

export const loadTrialTourSeenAt = (userId: string): string | null => {
  try {
    return window.localStorage.getItem(seenKey(userId))
  } catch {
    return null
  }
}

export const persistTrialTourSeenAt = (userId: string, at: string) => {
  try {
    window.localStorage.setItem(seenKey(userId), at)
  } catch {
    // Private mode or disabled storage: the tour shows again next time.
  }
}
